module.exports = __webpack_public_path__ + "static/reinvent-logo-8a625c7870b696245645129c170d3fec.png";